/**
 * Anzeigetext nach eingestellter Sprache wählen (#179).
 *
 * `lang` ist `i18n.resolvedLanguage`. In der englischen Oberfläche gewinnt der englische Text,
 * sonst der deutsche; ist der bevorzugte leer (null, undefined, '' oder nur Leerzeichen), kommt
 * der andere. Nur für die **Anzeige** — Sortierschlüssel und Bearbeitungsfelder bleiben bei den
 * Rohfeldern, damit sich Reihenfolge und gespeicherte Werte nicht mit dem Sprachumschalter ändern.
 */
export function pickLang(
  lang: string | null | undefined,
  de: string | null | undefined,
  en: string | null | undefined,
): string {
  const deText = de?.trim() ? de : '';
  const enText = en?.trim() ? en : '';
  return lang === 'en' ? enText || deText : deText || enText;
}
